const scrollInit = (anchor: HTMLAnchorElement) => {
  const scrollAnimation = (ID) => {
    const headerHeight = document.querySelector('.header').getBoundingClientRect().height;
    const offsetTop = document.getElementById(ID).getBoundingClientRect().top;
    const totalTop = offsetTop + document.documentElement.scrollTop;
    window.scrollTo({
      top: totalTop - (headerHeight + 10),
      behavior: 'smooth',
    });
  };

  anchor.addEventListener('click', (event: Event) => {
    const { href } = anchor;
    if (href.includes('#')) {
      event.preventDefault();
      const ID = href.split('#')[1];
      scrollAnimation(ID);
    }
  });
};

export default scrollInit;
